import React from 'react';
import { CREATION_PROGRESS_STEPS } from './wizardState';

type Props = {
  activeIndex: number;
};

export default function WizardCreatingPanel({ activeIndex }: Props) {
  return (
    <div className="wizard-creating-panel" role="status" aria-live="polite" aria-busy="true">
      <header className="wizard-step-header">
        <h2 className="wizard-step-title">Create alert</h2>
        <p className="muted wizard-step-intro">Setting up your alert — this usually takes a few seconds.</p>
      </header>
      <ol className="wizard-creating-steps">
        {CREATION_PROGRESS_STEPS.map((label, index) => {
          const done = index < activeIndex;
          const active = index === activeIndex;
          return (
            <li
              key={label}
              className={`wizard-creating-step${done ? ' wizard-creating-step--done' : ''}${
                active ? ' wizard-creating-step--active' : ''
              }`}
            >
              <span className="wizard-creating-step__marker" aria-hidden>
                {done ? '✓' : active ? <span className="spinner wizard-creating-step__spinner" /> : '○'}
              </span>
              <span>{label}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
